import React from "react";
import { Box, Button, InputAdornment, Stack, TextField, Typography, CircularProgress } from "@mui/material";
import { Link as LinkIcon } from "../../icons/FigmaControlIcons";

const PURPLE = "#7C3AED";
const PURPLE_HOVER = "#6D28D9";
const SOFT_BG = "#F7F5FF";
const SOFT_BORDER = "#EAE5FF";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 10,
    bgcolor: "#fff",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: SOFT_BORDER,
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D7CBFF",
  },
  "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: PURPLE,
    borderWidth: 2,
  },
};

export default function InlineLinkEntryCard({
  title = "Use Link",
  subtitle = "Paste a public link",
  value = "",
  onChange,
  onSubmit,
  placeholder = "https://...",
  buttonText = "Continue",
  helperText = "",
  errorText = "",
  disabled = false,
  loading = false,
}) {
  const hasValue = Boolean(String(value || "").trim());

  return (
    <Box
      sx={{
        border: `1px solid ${SOFT_BORDER}`,
        borderRadius: 2.5,
        bgcolor: "#fff",
        p: 1.5,
      }}
    >
      <Stack spacing={1.1}>
        <Stack direction="row" spacing={1.25} alignItems="center">
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: 2,
              display: "grid",
              placeItems: "center",
              bgcolor: SOFT_BG,
              border: `1px solid ${SOFT_BORDER}`,
              flex: "0 0 auto",
            }}
          >
            <LinkIcon sx={{ fontSize: 18, color: PURPLE }} />
          </Box>

          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: 12.5, fontWeight: 900, color: "#111827" }}>
              {title}
            </Typography>
            <Typography sx={{ fontSize: 11.5, color: "#6B7280", mt: 0.25 }}>
              {subtitle}
            </Typography>
          </Box>
        </Stack>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.1} alignItems={{ sm: "flex-start" }}>
          <TextField
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            fullWidth
            size="small"
            error={Boolean(errorText)}
            helperText={errorText || helperText || " "}
            disabled={disabled}
            onKeyDown={(event) => {
              if (event.key === "Enter" && hasValue && !disabled && !loading) {
                event.preventDefault();
                onSubmit?.();
              }
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LinkIcon sx={{ fontSize: 18, color: PURPLE }} />
                </InputAdornment>
              ),
            }}
            sx={{
              ...fieldSx,
              flex: 1,
            }}
          />

          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={disabled || loading || !hasValue}
            sx={{
              borderRadius: 999,
              textTransform: "none",
              fontWeight: 900,
              px: 2.35,
              py: 0.95,
              minWidth: 118,
              bgcolor: PURPLE,
              boxShadow: "0 8px 16px rgba(124,58,237,0.24)",
              "&:hover": { bgcolor: PURPLE_HOVER },
            }}
            startIcon={loading ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
          >
            {buttonText}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
